export default __webpack_public_path__ + "static/81853-2638f3b3cb591124d9ddf0752029b75a.jpg";